import React from 'react';
import TelemetryProvider from './components/Common/AppInsight/TelemetryProvider';
import {getAppInsights} from './components/Common/AppInsight/TelemetryService';
import Routes from './components/Routes';
import {initializeRedirection, initializeRedirectionV1} from './startup.js';
import env from './util/env';
import './util/svg';
import {createRoot} from 'react-dom/client';

initializeRedirection();
initializeRedirectionV1();

const root = createRoot(document.getElementById('mount'));

root.render(
	<TelemetryProvider instrumentationKey={env.getInstrumentationKey()} after={() => getAppInsights().trackPageView({name: window.location.pathname})}>
		<Routes />
	</TelemetryProvider>
);
